import React from 'react';
import ReactDOM from 'react-dom';
import Main from './Main';

ReactDOM.render((
    <Main />
    ), document.getElementById('root')
);


// WEBPACK FOOTER //
// ./src/index.js